import React from 'react'
import SharedFilters from '../../../components/SharedFilters'
import useStudentLogs from './hooks/useStudentLogs'
import StudentLogsTable from './components/StudentLogsTable'
import AppPagination from '../../../components/AppPagination'

export default function StudentLogsScreen() {
  const { state, actions } = useStudentLogs()

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-20">
      {/* ── Header ── */}
      <section className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">
            Cloud &amp; Inquiries
          </p>
          <div className="flex items-center gap-3 mt-1">
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-on-surface">
              Student Logs
            </h1>
            <span className="rounded-xl bg-surface-container-high px-3 py-1 text-xs font-bold text-on-surface-variant">
              {state.totalCount} entries
            </span>
          </div>
          <p className="mt-0.5 text-xs text-on-surface-variant">
            Comprehensive audit logs tracking student access, mobile logins, test reviews, note downloads, and feedback submissions.
          </p>
        </div>
      </section>

      {/* ── Shared Component Filters ── */}
      <SharedFilters
        visibleAccordionFilters={[
          'module',
          'period',
          'fromDate',
          'tillDate',
        ]}
        // Module
        moduleFilter={state.moduleFilter}
        setModuleFilter={actions.setModuleFilter}
        moduleOptions={state.options.modules}
        // Period
        periodFilter={state.periodFilter}
        setPeriodFilter={actions.setPeriodFilter}
        periodOptions={state.options.periods}
        // Date Range
        fromDate={state.fromDate}
        setFromDate={actions.setFromDate}
        tillDate={state.tillDate}
        setTillDate={actions.setTillDate}
        // Search & Reset
        searchText={state.searchText}
        setSearchText={actions.setSearchText}
        onReset={actions.handleResetFilters}
        onSearch={actions.loadData}
        showStatus={false}
      />

      {/* ── Student Logs Table & Pagination Wrapper ── */}
      <div className="flex flex-col gap-4">
        <StudentLogsTable
          records={state.pagedRecords}
          loading={state.loading}
        />

        {state.totalCount > 0 && (
          <div className="flex flex-col gap-3 rounded-2xl border border-outline-variant/25 bg-surface-container-lowest px-6 py-4 sm:flex-row sm:items-center sm:justify-between shadow-xs">
            <span className="text-xs font-medium text-on-surface-variant">
              Showing {state.rangeStart} to {state.rangeEnd} of {state.totalCount} entries
            </span>

            <AppPagination
              page={state.page}
              totalPages={state.totalPages}
              onPageChange={actions.setPage}
              onPrevious={actions.goToPreviousPage}
              onNext={actions.goToNextPage}
              canPrevious={state.page > 1}
              canNext={state.page < state.totalPages}
            />
          </div>
        )}
      </div>
    </div>
  )
}
